export default __webpack_public_path__ + "static/media/sql.c3406f0c.svg";